import _extends from "@babel/runtime/helpers/extends";
import React from 'react';
import { UserReview } from "./UserReview";

const UserReviews = ({
  reviews
}) => {
  return /*#__PURE__*/React.createElement(React.Fragment, null, reviews.map(review => /*#__PURE__*/React.createElement(UserReview, _extends({}, review, {
    key: review.id
  }))));
};

export default UserReviews;